






















import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";

type StatisticItem = {
    activity_id: number,
    content_pack_id: number,
    duration: number,
    players_count: string
}

@Component({
    components: {},
})

export default class TableColumn extends Vue {
    @Prop({required: true}) private readonly info!: Array<StatisticItem>;
    @Prop({required: true}) private readonly packs!: {[key: string]: Array<StatisticItem>}|null;
    @Prop({required: true}) private readonly name!: string;

    mounted(): void {

    }

    private getPackByPlayersCount(pack: Array<StatisticItem>, playersCount: string): StatisticItem|null
    {
        const filtered = pack.filter(item => item.players_count === playersCount);

        if (typeof filtered[0] === 'undefined') {
            return null;
        }
        return filtered[0];
    }
}
